import Terms, { PATH as TERMS } from './Terms'

export default { Terms }
export const PATH = { TERMS }
